import { useState, useEffect } from "react";
import { Trophy, TrendUp, TrendDown, Minus, ListChecks, ChartBar } from "@phosphor-icons/react";

// ─── Récord verificado — historial público de resultados ─────────────────────
// Muestra el récord REAL del mes actual desde /api/picks/public/record.
// Si el endpoint falla o no hay datos, muestra un estado honesto.
// NUNCA inventa estadísticas.
export default function RecordSection() {
  const [rec, setRec] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    let alive = true;
    fetch(`${API}/api/picks/public/record`)
      .then(r => r.json())
      .then(d => { if (alive) setRec(d); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, []);

  const noData = failed || (rec && !rec.has_data);

  const cards = [];
  if (rec && rec.has_data) {
    const streak = rec.current_streak || 0;
    cards.push(
      { icon: ChartBar,  value: `${rec.win_rate}%`,  label: "Efectividad del mes", gold: true },
      { icon: Trophy,    value: rec.wins,            label: "Señales ganadas" },
      {
        icon: streak > 0 ? TrendUp : streak < 0 ? TrendDown : Minus,
        value: streak !== 0 ? (streak > 0 ? `+${streak}` : `${streak}`) : "—",
        label: streak > 0 ? "ganadas seguidas" : streak < 0 ? "perdidas seguidas" : "sin racha activa",
        tone: streak > 0 ? "#10B981" : streak < 0 ? "#EF4444" : "#71717A",
      },
      { icon: ListChecks, value: rec.wins + rec.losses + rec.voids, label: "Señales evaluadas" },
    );
  }

  return (
    <section
      className="py-12 px-4 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #080810 0%, #050507 100%)", borderTop: "1px solid rgba(212,175,55,0.08)" }}
      data-testid="record-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <div className="text-[10px] tracking-[0.3em] uppercase font-black mb-2" style={{ color: "#D4AF37" }}>
            Récord verificado
          </div>
          <h2 className="font-black text-white" style={{ fontSize: "clamp(1.6rem, 5vw, 2.2rem)", letterSpacing: "-0.02em" }}>
            Números, no promesas
          </h2>
          <p className="text-sm mt-2" style={{ color: "#71717A" }}>
            {rec?.month_label
              ? `Resultados reales de ${rec.month_label}. Si un mes no ganamos, aquí también lo vas a ver.`
              : "Resultados reales del mes. Si un mes no ganamos, aquí también lo vas a ver."}
          </p>
        </div>

        {noData ? (
          <div className="rounded-2xl p-8 text-center" style={{ background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.08)" }}>
            <Trophy className="w-10 h-10 mx-auto mb-3" weight="fill" style={{ color: "#D4AF37", opacity: 0.5 }} />
            <div className="text-sm font-bold text-white mb-1">Récord en construcción</div>
            <div className="text-xs" style={{ color: "#71717A" }}>
              Estamos cerrando las primeras señales del mes. Vuelve pronto para ver los números reales.
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {cards.map((c, i) => (
              <div
                key={i}
                className="rounded-2xl p-5 text-center"
                style={{
                  background: c.gold ? "rgba(212,175,55,0.07)" : "rgba(255,255,255,0.02)",
                  border: c.gold ? "1px solid rgba(212,175,55,0.35)" : "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <c.icon className="w-6 h-6 mx-auto mb-2" weight="fill"
                  style={{ color: c.tone || (c.gold ? "#D4AF37" : "#A1A1AA") }} />
                <div className="stat-number text-white" style={{ fontSize: "clamp(1.5rem, 5vw, 2rem)" }}>
                  {c.value}
                </div>
                <div className="text-[10px] uppercase tracking-widest font-bold mt-1" style={{ color: "#71717A" }}>
                  {c.label}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
